import { defineStore } from 'pinia';

export const useReceiptStoreEvrt = defineStore('receipt', {
  state: () => ({
    receiptNumber: '',
    branchCode: '',
    firstName: '',
    lastName: '',
    address: '',
    city: '',
     tax_id: '',
    postalCode: '',
    receiptsCode: '', 
    storeNumber: '',   
    email: '', //
    selectedType: '', 
    full_name: '',  // 
    last_name: '',  // 
    passport_no: '',  // 
    branch_code:'',
    country:'', 
    post_code: '', //
    customer_address: '', //
    customer_address_2: '',  //
    phone_number: '', //
    departureDate: '', //
    arrivalDate: '',  // 
    token:'',
    nationality_name: '', //
    cityName: '', 
     country_code_iso3:'', 
    country_name: '', //
    email_important: '', 
    city_name: '', //

  }),
  actions: {
    clear() {
      this.receiptNumber = '';
      this.branchCode = '';
      this.firstName = '';
      this.lastName = '';
      this.address = '';
      this.city = '';
      this.country = '';
      this.postalCode = '';
      this.token = '';
    }
  }
});
